import { cannedWorkTaskQuery } from "@common/api/quoting/canned"
import {
  createFileRoute,
  getRouteApi,
  Outlet,
  useNavigate,
} from "@tanstack/react-router"
import { TaskPane } from "@/routes/_layout/templates/-components/task-pane"
import { TaskStepper } from "@/routes/_layout/templates/-components/task-stepper"

const listRoute = getRouteApi("/_layout/templates/quotes_/$packageId/_list")

export const Route = createFileRoute(
  "/_layout/templates/quotes_/$packageId/_list/tasks/$taskId",
)({
  staticData: { detailSidebar: true },
  loader: ({ context: { queryClient }, params: { taskId } }) =>
    queryClient.fetchQuery(cannedWorkTaskQuery({ task_id: taskId })),
  component: TemplateQuoteTaskRoute,
})

function TemplateQuoteTaskRoute(): React.ReactElement {
  const { packageId, taskId } = Route.useParams()
  const filters = listRoute.useSearch()
  const navigate = useNavigate()

  return (
    <TaskPane
      taskId={taskId}
      onClose={() =>
        navigate({
          to: "/templates/quotes/$packageId",
          params: { packageId },
          search: true,
        })
      }
      actions={
        <TaskStepper
          taskId={taskId}
          filters={filters}
          packageId={packageId}
          onOpen={(id) =>
            navigate({
              to: "/templates/quotes/$packageId/tasks/$taskId",
              params: { packageId, taskId: id },
              search: true,
            })
          }
        />
      }
    >
      <Outlet />
    </TaskPane>
  )
}
